/* eslint-disable no-new, no-restricted-syntax */
import React, { useEffect } from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';

// Actions
import * as ReportActions from 'store/ducks/reports/actions';
import { listSellingPointsRequest } from 'store/ducks/sellingPoints/actions';

// Types
import { ApplicationState } from 'store';
import { SellingPointInterface } from 'store/ducks/sellingPoints/types';

// Styles
import useStyles from './sellingPointFilter.styles';

const SellingPointFilter: React.FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const filteredSellingPoint = useSelector(
    (state: ApplicationState) => state.reports.selectedSellingPoint,
  );

  const sellingPointsList = useSelector(
    (state: ApplicationState) => state.sellingPoints.sellingPointsList,
  );

  const handleSellingPoint = (sellingPoint: SellingPointInterface) => {
    const updated = [...filteredSellingPoint];

    const index = filteredSellingPoint.findIndex(
      (s) => s.id === sellingPoint.id,
    );

    if (index === -1) {
      updated.push({
        id: sellingPoint.id || '',
        name: sellingPoint.name || '',
      });
    } else updated.splice(index, 1);

    dispatch(
      ReportActions.setSelectedSellingPoint({
        selectedSellingPoint: updated,
      }),
    );
  };

  useEffect(() => {
    if (!sellingPointsList.length) {
      dispatch(listSellingPointsRequest({ body: { _limit: 9999 } }));
    }
  }, [dispatch, sellingPointsList]);

  return (
    <Box marginTop={1}>
      <List dense>
        {Array.isArray(sellingPointsList) &&
          sellingPointsList.map((sellingPoint) => (
            <ListItem key={sellingPoint.id} button>
              <ListItemText
                id={sellingPoint.id}
                primary={sellingPoint.name}
                onClick={() => handleSellingPoint(sellingPoint)}
                classes={{ root: classes.itemText }}
              />
              <ListItemSecondaryAction>
                <Checkbox
                  edge='end'
                  color='primary'
                  onClick={() => handleSellingPoint(sellingPoint)}
                  checked={
                    !!filteredSellingPoint.find((s) => s.id === sellingPoint.id)
                  }
                  inputProps={{ 'aria-labelledby': sellingPoint.id }}
                />
              </ListItemSecondaryAction>
            </ListItem>
          ))}
      </List>
    </Box>
  );
};

export { SellingPointFilter };
export default SellingPointFilter;
